export default "__VITE_ASSET__Cmgksxiz__"